import {
  MdHomeMax,
  MdHouse,
  MdOutlineDashboard,
  MdOutlinePriceCheck,
  MdOutlineDeliveryDining,
} from "react-icons/md";
import { IoHomeOutline } from "react-icons/io5";
import { MdOutlineRateReview } from "react-icons/md";
import { CiDeliveryTruck } from "react-icons/ci";
import { FaBloggerB, FaRegUserCircle } from "react-icons/fa";
import { IoCartOutline } from "react-icons/io5";
import { RiPriceTagLine, RiProductHuntLine } from "react-icons/ri";
import { AiOutlineBank } from "react-icons/ai";
import { CiLink } from "react-icons/ci";
import { FaCity } from "react-icons/fa";
import { MdOutlineCategory } from "react-icons/md";
import { LuTextQuote } from "react-icons/lu";
import { BiSolidCarousel } from "react-icons/bi";
import { IoIosPricetags } from "react-icons/io";
import { TbBrandSnowflake } from "react-icons/tb";
import { BsIntersect } from "react-icons/bs";
import { CgIfDesign } from "react-icons/cg";
import {
  MdOutlineInventory,
  MdOutlineSettings,
  MdOutlineHome,
  MdOutlineAttachMoney,
  MdOutlineConstruction,
  MdOutlineArticle,
  MdOutlineDesignServices,
} from "react-icons/md";
import { GrProjects } from "react-icons/gr";
import Dashboard from "../Containers/Dashboard/Dashboard.jsx";
import Products from "../Containers/Products/ProductList/Products.jsx";
import Categories from "../Containers/Categories/CategoriesList/Categories.jsx";
import Users from "../Containers/Users/Users.jsx";
import Order from "../Containers/Orders/Order.jsx";
import Invoice from "../Containers/Orders/Invoice.jsx/Invoice.jsx";
import UserView from "../Containers/Users/UserView/UserView.jsx";
import Review from "../Containers/Reviews/review.jsx";
import ProductDeliveryCharges from "../Containers/ProductDeliveryCharges/ProductDeliveryCharges.jsx";
import CategoryView from "../Containers/Categories/CategoriesView/CategoryView.jsx";
import ProductView from "../Containers/Products/ProductView/ProductView.jsx";
import CategoriesProducts from "../Containers/Categories/CategoriesDetails/CategoriesProducts.jsx";
import BankAccount from "../Containers/BankAccount/BankAccount.jsx";
import VerifyPayments from "../Containers/Orders/VerifyPayments/VerifyPayments.jsx";
import UtmLinks from "../Containers/UtmLinks/UtmLinks.jsx";
import Profile from "../Containers/Profile/Profile.jsx";
import QuotationPage from "../Containers/Quotation/QuotationPage.jsx";
import BannerManagement from "../Containers/CarouselProducts/CarouselProducts.jsx";
import Pricing from "../Containers/Pricing/Pricing.jsx";
import BrandManagement from "../Containers/Brands/Brands.jsx";
import TentiveCost from "../Containers/TentativeCost/TentativeCost.jsx";
import HomeScreen from "../Containers/HomeScreen/HomeScreen.jsx";
import DataManagement from "../Components/HomeScreen/HomeScreenData.jsx";
import HouseDesing from "../Containers/HouseDesign/HouseDesing.jsx";
import BlogCategories from "../Containers/BlogCategories/BlogCategoriesList/Blog.Categories.jsx";
import BlogLinkedCategoriesList from "../Containers/BlogCategories/BlogLinkedCategoriesList/BlogLinkedCategoriesList.jsx";
import BlogLinkedCategoryDetail from "../Containers/BlogCategories/BlogLinkedCategoriesListDetails/BlogLinkedCategoriesDetail.jsx";
import Blog from "../Containers/Blog/Blog.jsx";
import BlogView from "../Containers/Blog/BlogView.jsx";
import HouseDesignDetails from "../Containers/HouseDesign/HouseDesignDetails.jsx";
import FrontElevationDetails from "../Containers/FrontElevation/FrontElevationDetails.jsx";
import BuyPlans from "../Containers/BuyPlans/BuyPlans.js";
import BuyThisPlanDetails from "../Containers/BuyPlans/buyThisPlanDetails.jsx";
import OurProjects from "../Containers/Our-Projects/OurProjects.jsx";
import OurProjectsDetails from "../Containers/Our-Projects/OurProjects-Details.jsx";
import OurProjectCategories from "../Containers/Our-Projects/OurProjectCategories.jsx";
import InteriorDesignCategory from "../Containers/InteriorDesingCategories/InteriorDesignCategor.jsx";
import InteriorDesign from "../Containers/InteriorDesign/InteriorDesign.jsx";
import InteriorDesignDetails from "../Containers/InteriorDesign/InteriorDesignDetails.jsx";
import OutStationZonePage from "../Containers/DeliveryManagement/OutStationZonePage.jsx";
import OutStationBaseRatesPage from "../Containers/DeliveryManagement/OutStationBaseRatesPage.jsx";
import Cities from "../Containers/DeliveryManagement/Cities.jsx";
import InStationZonePage from "../Containers/DeliveryManagement/InStationZonePage.jsx";
import InStationBaseRatePage from "../Containers/DeliveryManagement/InStationBaseRatePage.jsx";

const routes = [
  {
    path: "/profile",
    element: Profile,
    visible: false,
  },
  {
    path: "/dashboard",
    element: Dashboard,
    label: "Dashboard",
    icon: <MdOutlineDashboard size={24} />,
  },
  {
    label: "General",
    icon: <MdOutlineSettings size={30} />,
    isGroup: true,
    children: [
      {
        path: "/users",
        element: Users,
        label: "Users",
        icon: <FaRegUserCircle size={24} />,
      },
      {
        path: "/bank-account-details",
        element: BankAccount,
        label: "Bank Account Details",
        icon: <AiOutlineBank size={24} />,
      },
      {
        path: "/social-links",
        element: UtmLinks,
        label: "Generate Social Links",
        icon: <CiLink size={24} />,
      },
      {
        path: "/home-screen",
        element: HomeScreen,
        label: "HomeScreen Management",
        icon: <MdHomeMax size={24} />,
      },
    ],
  },
  {
    label: "Shop",
    icon: <MdOutlineInventory size={30} />,
    isGroup: true,
    children: [
      {
        path: "/category",
        element: Categories,
        label: "Categories",
        icon: <MdOutlineCategory size={24} />,
      },
      {
        path: "/products",
        element: Products,
        label: "Products",
        icon: <RiProductHuntLine size={24} />,
      },
      {
        path: "/quotation",
        element: QuotationPage,
        label: "Generate Quotation",
        icon: <LuTextQuote size={24} />,
      },
      {
        path: "/orders",
        element: Order,
        label: "Orders",
        icon: <IoCartOutline size={24} />,
      },
      {
        path: "/reviews",
        element: Review,
        label: "Manage Reviews",
        icon: <MdOutlineRateReview size={24} />,
      },
      {
        path: "/product-delivery-charges",
        element: ProductDeliveryCharges,
        label: "Product Delivery Charges",
        icon: <CiDeliveryTruck size={24} />,
      },
      {
        path: "/add-brands",
        element: BrandManagement,
        label: "Brands Management",
        icon: <TbBrandSnowflake size={24} />,
      },
      {
        path: "/manage-carousel",
        element: BannerManagement,
        label: "Carousel Items",
        icon: <BiSolidCarousel size={24} />,
      },
    ],
  },
  {
    label: "Delivery Management",
    icon: <MdOutlineDeliveryDining size={30} />,
    isGroup: true,
    children: [
      {
        path: "/out-station-zones",
        element: OutStationZonePage,
        label: "Out Station Zones",
        icon: <CiDeliveryTruck size={24} />,
      },
      {
        path: "/out-station-base-rate",
        element: OutStationBaseRatesPage,
        label: "Out Station Base Rate",
        icon: <MdOutlineRateReview size={24} />,
      },
      {
        path: "/cities",
        element: Cities,
        label: "Add Cities",
        icon: <FaCity size={24} />,
      },
      {
        path: "/in-station-zones",
        element: InStationZonePage,
        label: "In Station Zones",
        icon: <CiDeliveryTruck size={24} />,
      },
      {
        path: "/in-station-base-rate",
        element: InStationBaseRatePage,
        label: "In Station Base Rate",
        icon: <MdOutlineRateReview size={24} />,
      },
    ],
  },
  {
    label: "House Design",
    icon: <MdOutlineHome size={30} />,
    isGroup: true,
    children: [
      {
        path: "/house-design",
        element: HouseDesing,
        label: "House Design",
        icon: <MdHouse size={24} />,
      },
      {
        path: "/buy-plans",
        element: BuyPlans,
        label: "Buy Plans",
        icon: <MdOutlinePriceCheck size={24} />,
      },
    ],
  },
  {
    label: "Pricing",
    icon: <MdOutlineAttachMoney size={30} />,
    isGroup: true,
    children: [
      {
        path: "/pricing",
        element: Pricing,
        label: "Add Pricing",
        icon: <IoIosPricetags size={24} />,
      },
    ],
  },
  {
    label: "Construction Calculator",
    icon: <MdOutlineConstruction size={30} />,
    isGroup: true,
    children: [
      {
        path: "/tentative-cost",
        element: TentiveCost,
        label: "Tentative Cost",
        icon: <RiPriceTagLine size={24} />,
      },
    ],
  },
  {
    label: "Blogs",
    icon: <MdOutlineArticle size={30} />,
    isGroup: true,
    children: [
      {
        path: "/blog-categories",
        element: BlogCategories,
        label: "Blog Categories",
        icon: <MdOutlineRateReview size={24} />,
      },
      {
        path: "/blogs",
        element: Blog,
        label: "Blogs",
        icon: <FaBloggerB size={24} />,
      },
    ],
  },
  {
    label: "Interior Designs",
    icon: <MdOutlineDesignServices size={30} />,
    isGroup: true,
    children: [
      {
        path: "/interior-design-categories",
        element: InteriorDesignCategory,
        label: "Interior Design Categories",
        icon: <BsIntersect size={24} />,
      },
      {
        path: "/interior-design",
        element: InteriorDesign,
        label: "Interior Design",
        icon: <CgIfDesign size={24} />,
      },
    ],
  },
  {
    path: "/category/view",
    element: CategoryView,
    label: "Category",
    icon: <IoHomeOutline size={30} />,
    visible: false,
  },
  {
    path: "/category/view/products",
    element: CategoriesProducts,
    label: "Category",
    icon: <IoHomeOutline size={30} />,
    visible: false,
  },
  {
    path: "/products/view",
    element: ProductView,
    label: "Products",
    visible: false,
  },
  {
    path: "/users/view",
    element: UserView,
    label: "Users",
    icon: <FaRegUserCircle size={30} />,
    visible: false,
  },
  {
    path: "/orders/invoice",
    element: Invoice,
    label: "Invoice",
    icon: <CiDeliveryTruck size={30} />,
    visible: false,
  },
  {
    path: "/orders/verify-payment",
    element: VerifyPayments,
    label: "Invoice",
    icon: <CiDeliveryTruck size={30} />,
    visible: false,
  },
  {
    path: "/house-design/:id",
    element: HouseDesignDetails,
    visible: false,
  },
  // {
  //   path: "/front-elevation",
  //   element: FrontElevation,
  //   label: "Front Elevation",
  //   icon: <HiOutlineBuildingStorefront size={30} />,
  // },
  {
    path: "/front-elevation/:id",
    element: FrontElevationDetails,
    visible: false,
  },
  {
    path: "/data-management",
    element: DataManagement,
    visible: false,
  },
  {
    path: "/blog-category/view/",
    element: BlogLinkedCategoriesList,
    visible: false,
  },
  {
    path: "/blog-categories/view/details",
    element: BlogLinkedCategoryDetail,
    visible: false,
  },
  {
    path: "/blog/view/:id",
    element: BlogView,
    visible: false,
  },
  {
    path: "/blogs/edit/:id",
    element: Blog,
    visible: false,
  },
  {
    path: "/buy-this-plan/details",
    element: BuyThisPlanDetails,
    visible: false,
  },
  {
    path: "/our-project-categories",
    element: OurProjectCategories,
    label: "Our Projects",
    icon: <GrProjects size={30} />,
  },
  {
    path: "/our-projects/:id",
    element: OurProjects,
    visible: false,
  },
  {
    path: "/our-projects/view/:id",
    element: OurProjectsDetails,
    visible: false,
  },
  {
    path: "/interior-design/:id",
    element: InteriorDesignDetails,
    visible: false,
  },
];

export default routes;
